import { Heart, Check } from "lucide-react";
import { DECORACOES, formatBRL } from "../data/cabanas";

export const Decoracao = () => (
  <section id="decoracao" className="py-24 bg-[#1b4332] grain-overlay" data-testid="decoracao-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6">
      <div className="max-w-2xl mb-14">
        <p className="text-[#d4a373] text-xs uppercase tracking-[0.3em] font-bold mb-3 flex items-center gap-2">
          <Heart className="h-4 w-4" /> Adicional opcional
        </p>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#faf7f2]">
          Decoração Romântica
        </h2>
        <p className="mt-4 text-[#f5f0eb]/80 text-base leading-relaxed">
          Surpreenda quem você ama. Escolha uma das opções no formulário de reserva da sua
          cabana e preparemos tudo antes da sua chegada.
        </p>
      </div>
      <div className="grid md:grid-cols-3 gap-8">
        {DECORACOES.filter((d) => d.preco > 0).map((d) => (
          <div
            key={d.id}
            data-testid={`decor-card-${d.id}`}
            className="bg-[#faf7f2] rounded-2xl overflow-hidden shadow-2xl flex flex-col transition-transform duration-300 hover:-translate-y-2"
          >
            <img src={d.imagem} alt={d.nome} className="w-full aspect-[4/3] object-cover" loading="lazy" />
            <div className="p-6 flex flex-col gap-4 flex-1">
              <div className="flex items-baseline justify-between gap-2">
                <h3 className="text-xl font-bold text-[#1b4332]">{d.nome}</h3>
                <span className="text-lg font-bold text-[#b85d39]">{formatBRL(d.preco)}</span>
              </div>
              <ul className="flex flex-col gap-2 flex-1">
                {d.itens.map((item) => (
                  <li key={item} className="flex items-start gap-2 text-sm text-[#1e2923]">
                    <Check className="h-4 w-4 text-[#2d5a27] mt-0.5 shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
              <p className="text-xs uppercase tracking-wider font-bold text-[#b85d39] border-t border-[#e2d9cd] pt-3">
                {d.destaque}
              </p>
            </div>
          </div>
        ))}
      </div>
      <p className="mt-10 text-center text-[#f5f0eb]/70 text-sm">
        Para incluir, selecione a opção desejada no formulário de reserva da cabana escolhida.
      </p>
    </div>
  </section>
);
